import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import GenericFlyout from "../modal/GenericFlyout";
import "./mega-menu.scss";

const MegaMenuDropdown = ({ id = "id", label = "", children }) => {
  const isSmall = useMediaQuery({ maxWidth: 767.98 });

  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => setShowMenu(!showMenu);

  return (
    <>
      <button
        id={id + "-menu-button"}
        aria-haspopup="true"
        className="nav-link"
        style={{
          backgroundColor: showMenu ? "#fff" : "transparent",
          border: 0
        }}
        aria-expanded={showMenu}
        onClick={toggleMenu}
      >
        {label}
      </button>
      <GenericFlyout
        id={id + "-dropdown"}
        isOpen={showMenu}
        toggle={toggleMenu}
        noCloseBtn
        excludeFromClose={id + "-menu-button"}
        align={"top-center"}
        isMobileSubMenu
        width={1200}
      >
        <div
          className={"mega-menu-content"}
          style={{
            width: "100%",
            height: isSmall ? "100%" : "fit-content",
            maxHeight: `calc(100vh - var(--safe-area-inset-top) - var(--safe-area-inset-bottom) - var(--menu-height) - var(--padding-top))`,
            background: "#fff"
          }}
        >
          {children}
        </div>
      </GenericFlyout>
    </>
  );
};

export default MegaMenuDropdown;
